export const CLIENTTYPE_DELETE_RESET = 'CLIENTTYPE_DELETE_RESET'
export const CLIENTTYPE_DELETE_SET_ERROR = 'CLIENTTYPE_DELETE_SET_ERROR'
export const CLIENTTYPE_DELETE_SET_DELETED = 'CLIENTTYPE_DELETE_SET_DELETED'
export const CLIENTTYPE_DELETE_TOGGLE_LOADING = 'CLIENTTYPE_DELETE_TOGGLE_LOADING'
